import React from 'react';
import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { compatWrapper } from '@backstage/core-compat-api';

const consumedApisCard = EntityCardBlueprint.make({
  name: 'consumed-apis',
  params: {
    filter: 'kind:component',
    loader: async () =>
      import('./ConditionalCards').then(m =>
        compatWrapper(React.createElement(m.ConditionalConsumedApisCard)),
      ),
  },
});

const providedApisCard = EntityCardBlueprint.make({
  name: 'provided-apis',
  params: {
    filter: 'kind:component',
    loader: async () =>
      import('./ConditionalCards').then(m =>
        compatWrapper(React.createElement(m.ConditionalProvidedApisCard)),
      ),
  },
});

const dependsOnComponentsCard = EntityCardBlueprint.make({
  name: 'depends-on-components',
  params: {
    filter: 'kind:component',
    loader: async () =>
      import('./ConditionalCards').then(m =>
        compatWrapper(React.createElement(m.ConditionalDependsOnComponentsCard)),
      ),
  },
});

const dependsOnResourcesCard = EntityCardBlueprint.make({
  name: 'depends-on-resources',
  params: {
    filter: 'kind:component',
    loader: async () =>
      import('./ConditionalCards').then(m =>
        compatWrapper(React.createElement(m.ConditionalDependsOnResourcesCard)),
      ),
  },
});

const hasSubcomponentsCard = EntityCardBlueprint.make({
  name: 'has-subcomponents',
  params: {
    filter: 'kind:component',
    loader: async () =>
      import('./ConditionalCards').then(m =>
        compatWrapper(React.createElement(m.ConditionalHasSubcomponentsCard)),
      ),
  },
});

export const conditionalCardsPlugin = createFrontendPlugin({
  pluginId: 'conditional-entity-cards',
  extensions: [
    consumedApisCard,
    providedApisCard,
    dependsOnComponentsCard,
    dependsOnResourcesCard,
    hasSubcomponentsCard,
  ],
});
